// extracted by mini-css-extract-plugin
export default {"production-wrapper":"table_production-wrapper__-RJia","hide-long-text":"table_hide-long-text__PKuQI"};